import { useQuery } from "@apollo/react-hooks";
import { get } from "lodash";
import React, { useCallback, useReducer } from "react";
import { GET_CHANNEL_TEAMS } from "../../graphql/queries/channel-team";
import { reducerFn } from "../../helper";
import { AutoCompleteHasSearchPolaris } from "../shared/AutoCompleteHasSearchPolaris";

export default function ChannelTeamAutocomplete({ onChange, value }) {
    const [filter, setFilter] = useReducer(reducerFn, {
        limit: 20,
        offset: 0,
        search: "",
    });

    const { data, loading } = useQuery(GET_CHANNEL_TEAMS, {
        variables: {
            filter,
        },
    });

    const handleSearchChange = useCallback((search) => {
        setFilter({ search });
    }, []);

    const handleChange = useCallback(
        (object) => {
            onChange(object ? object : undefined);
        },
        [onChange],
    );

    return (
        <AutoCompleteHasSearchPolaris
            value={value}
            label="Channel Team"
            data={getOptions(data)}
            onChangeSearch={handleSearchChange}
            onChange={handleChange}
            allowMultiple={false}
            loading={loading}
        />
    );
}

function getOptions(data) {
    const nodes = get(data, "getChannelTeams.nodes") || [];

    return nodes
        .map((item) =>
            item?.id ? { value: item.id, label: item.name } : undefined,
        )
        .filter(Boolean);
}
